import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PreliminaryInfo } from '../../domain/person';
import { continueApplicationProcessing } from '../../features/application/reducers/application';

const INITIAL_PERSONAL_INFO: PreliminaryInfo = {
  email: '',
  phone: '',
};

type PreliminaryInfoState = {
  info: PreliminaryInfo;
};

const initialState: PreliminaryInfoState = {
  info: INITIAL_PERSONAL_INFO,
};

const slice = createSlice({
  name: 'preliminaryInfo',
  initialState,
  reducers: {
    savePreliminaryInfo: (state, action: PayloadAction<PreliminaryInfo>) => ({
      ...state,
      info: action.payload,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(
      continueApplicationProcessing,
      (
        state,
        {
          payload: {
            response: { applicantCredentials },
          },
        },
      ) => {
        if (applicantCredentials) {
          return {
            ...state,
            info: {
              email: applicantCredentials.email,
              phone: applicantCredentials.phoneNumber,
            },
          };
        } else {
          return state;
        }
      },
    );
  },
});

export const { savePreliminaryInfo } = slice.actions;

export const preliminaryInfoReducer = slice.reducer;
